var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "failTitle"
  }, "Fail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "failTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,5 C28.2842712,5 35,11.7157288 35,20 C35,28.2842712 28.2842712,35 20,35 C11.7157288,35 5,28.2842712 5,20 C5,11.7157288 11.7157288,5 20,5 Z M20,7 C12.8202983,7 7,12.8202983 7,20 C7,27.1797017 12.8202983,33 20,33 C27.1797017,33 33,27.1797017 33,20 C33,12.8202983 27.1797017,7 20,7 Z M22.6077952,16.4319454 C22.9977,16.1238759 23.5651297,16.1471889 23.928409,16.5048557 C24.3219616,16.892328 24.3268906,17.5254738 23.9394183,17.9190264 L23.9394183,17.9190264 L21.398,20.5 L23.9394183,23.0809736 C24.3268906,23.4745262 24.3219616,24.107672 23.928409,24.4951443 C23.5651297,24.8528111 22.9977,24.8761241 22.6077952,24.5680546 L22.5142383,24.4841351 L19.995,21.925 L17.475738,24.4841351 L17.3821811,24.5680546 C16.9922763,24.8761241 16.4248465,24.8528111 16.0615672,24.4951443 C15.6680147,24.107672 15.6630857,23.4745262 16.050558,23.0809736 L16.050558,23.0809736 L18.591,20.5 L16.050558,17.9190264 C15.6630857,17.5254738 15.6680147,16.892328 16.0615672,16.5048557 C16.4248465,16.1471889 16.9922763,16.1238759 17.3821811,16.4319454 L17.475738,16.5158649 L19.995,19.074 L22.5142383,16.5158649 Z",
    fill: "#FC5C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C8.954305,0 0,8.954305 0,20 C0,31.045695 8.954305,40 20,40 C31.045695,40 40,31.045695 40,20 C40,8.954305 31.045695,0 20,0 Z M20,5 C28.2842712,5 35,11.7157288 35,20 C35,28.2842712 28.2842712,35 20,35 C11.7157288,35 5,28.2842712 5,20 C5,11.7157288 11.7157288,5 20,5 Z",
    fill: "#F6F6F6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.bb1a8aeb8515d56de8020a944e734fdd.svg";
export { ForwardRef as ReactComponent };